<div class="info-header row space-between">
  <span class="col-11">INFORMATION</span>
  <button
    type="button"
    class="collapse-button col-1"
    [ngClass]="shouldExpand ? 'expand' : 'collapse'"
    (click)="shouldExpand = !shouldExpand"
    >
    <mat-icon>expand_more</mat-icon>
  </button>
</div>
<div class="info-container" [ngClass]="shouldExpand ? 'expand' : 'collapse'">
  <div class="row align-top">
    <div class="col-md-8 col-lg-9 row align-top gutters">
      <div *ngTemplateOutlet="item; context: { tRow: row1 }"></div>
    </div>
    <div class="col-md-4 col-lg-3 row align-top">
      <div *ngTemplateOutlet="item; context: { tRow: row2 }"></div>
    </div>
  </div>
</div>
<div class="assignments">
  <div class="assignments-title">ASSIGNMENTS</div>
  @for (outlet of outlets; track outlet) {
    <div class="outlet-section">
      <a [href]="outlet.link" target="_blank" class="outlet-title">{{outlet.name}}</a>
      <table mat-table [dataSource]="outlet.credits" class="outlet-table stripped-table">
        <ng-container matColumnDef="name">
          <th *matHeaderCellDef mat-header-cell>Credit</th>
          <td *matCellDef="let item" mat-cell>{{item.name}}</td>
        </ng-container>
        <ng-container matColumnDef="equity">
          <th *matHeaderCellDef mat-header-cell>Equity</th>
          <td *matCellDef="let item" mat-cell>{{item.equity | currency}}@if (item.is_manual || item.is_calculated) {
            <mat-icon>emergency</mat-icon>
            }@if (item.is_calculated) {
            <mat-icon>emergency</mat-icon>
          }</td>
        </ng-container>
        <ng-container matColumnDef="ownership">
          <th *matHeaderCellDef mat-header-cell>Ownership</th>
          <td *matCellDef="let item" mat-cell>{{item.ownership}}%</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['name', 'equity', 'ownership']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['name', 'equity', 'ownership']"></tr>
      </table>
      <div class="legend">
        <div><mat-icon>emergency</mat-icon> — Denotes manually estimated gross equity values.</div>
        <div><mat-icon>emergency</mat-icon><mat-icon>emergency</mat-icon> — Denotes calculated gross equity values using an 8% load (4% for certificated).</div>
      </div>
    </div>
  }
</div>

<ng-template #item let-tRow="tRow">
  @for (tData of tRow; track tData) {
    <div
      [class]="getColumnClasses(tRow, tData)"
      [attr.rowspan]="tData.expandRow ? 2 : 1"
      >
      <b>{{ tData.key }}: </b>
      @if (!isArray(tData.value)) {
        <span>
          @if (tData.link) {
            <a [href]="tData.link" target="_blank">{{
              tData.value
            }}</a>
          }
          @if (!tData.link) {
            <span>{{ tData.value }}</span>
          }
        </span>
      }
      @if (isArray(tData.value)) {
        <ul>
          @for (list of tData.value; track list) {
            <li>
              @if (isString(list)) {
                <span>{{ list }}</span>
              }
              @if (!isString(list)) {
                <span>
                  @if (list.link) {
                    <a [href]="list.link" target="_blank">{{
                      list.name
                    }}</a>
                  }
                  @if (!list.link) {
                    <span>{{ list.name }}{{list.equity ? ' - '  + (list.equity | currency) : ''}}</span>
                  }
                </span>
              }
            </li>
          }
        </ul>
      }
    </div>
  }
</ng-template>
